<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="flex flex-align-center gap-sm">
          <app-back-button [ariaLabel]="'settings.back' | translate" />
          <span>{{ 'settings.teams.title' | translate }}</span>
        </div>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      @if (teams().length === 0) {
        <p class="empty-state" data-testid="teams-empty">{{ 'settings.teams.empty' | translate }}</p>
      } @else {
        <ul class="team-list" data-testid="team-list">
          @for (team of teams(); track team.id) {
            <li class="team-item" [attr.data-testid]="'team-row-' + team.id">
              <div class="team-row flex flex-align-center flex-justify-space-between gap-sm">
                <button type="button" class="team-name-button flex flex-align-center gap-xs" (click)="toggleMembers(team)"
                  [attr.data-testid]="'expand-team-' + team.id">
                  <app-icon [name]="expandedTeamId() === team.id ? 'chevron-down' : 'chevron-right'" [size]="16" />
                  <span>{{ team.name }}</span>
                  @if (team.default_tag_id && tagLabels().get(team.default_tag_id); as tagLabel) {
                    <span class="team-default-tag">{{ tagLabel }}</span>
                  }
                  @if (!team.is_active) {
                    <span class="team-inactive-badge">{{ 'settings.teams.inactive' | translate }}</span>
                  }
                </button>
                <div class="flex gap-xs">
                  <app-button variant="text" (click)="toggleActive(team)" [attr.data-testid]="'toggle-team-' + team.id">
                    {{ (team.is_active ? 'settings.teams.deactivate' : 'settings.teams.activate') | translate }}
                  </app-button>
                  <app-button variant="text" (click)="openEdit(team)" [attr.data-testid]="'edit-team-' + team.id">
                    <app-icon name="pencil" [size]="14" />
                  </app-button>
                </div>
              </div>

              @if (expandedTeamId() === team.id) {
                <div class="team-members" [attr.data-testid]="'team-members-' + team.id">
                  @if (members().length === 0) {
                    <p class="empty-state">{{ 'settings.teams.noMembers' | translate }}</p>
                  } @else {
                    <ul class="member-list">
                      @for (member of members(); track member.id) {
                        <li class="member-row flex flex-align-center flex-justify-space-between gap-sm" [attr.data-testid]="'member-row-' + member.id">
                          <span>{{ memberName(member.user_id) }}</span>
                          <div class="flex flex-align-center gap-xs">
                            <app-button variant="text" size="sm"
                              (click)="setMemberRole(member, member.team_role === 'lead' ? 'member' : 'lead')"
                              [attr.data-testid]="'toggle-role-' + member.id">
                              {{ (member.team_role === 'lead' ? 'settings.teams.role.lead' : 'settings.teams.role.member') | translate }}
                            </app-button>
                            <app-button variant="text" size="sm" (click)="removeMember(member)" [attr.data-testid]="'remove-member-' + member.id">
                              <app-icon name="x" [size]="14" />
                            </app-button>
                          </div>
                        </li>
                      }
                    </ul>
                  }
                  @if (availableUsers().length > 0) {
                    <form [formGroup]="addMemberForm" class="add-member-row flex flex-align-center gap-sm">
                      <formly-form [form]="addMemberForm" [fields]="addMemberFields" [model]="addMemberModel" class="add-member-field" />
                      <app-button variant="outlined" size="sm" (click)="addMember(team.id)" [attr.data-testid]="'add-member-button-' + team.id">
                        {{ 'settings.teams.addMember' | translate }}
                      </app-button>
                    </form>
                  }
                </div>
              }
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions>
      <app-button variant="filled" (click)="openCreate()" data-testid="new-team-button">
        <app-icon name="plus" />
        {{ 'settings.teams.new' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>

@if (showEditor()) {
  <app-modal-dialog (backdropClick)="closeEditor()">
    <div header>
      <div class="heading-md">{{ (editing() ? 'settings.teams.editTitle' : 'settings.teams.newTitle') | translate }}</div>
    </div>
    <div content>
      @if (error()) {
        <div class="error-container p-md" data-testid="team-form-error">{{ error() }}</div>
      }
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" />
      </form>
    </div>
    <div footer>
      <app-button variant="text" (click)="closeEditor()" data-testid="cancel-team-button">
        {{ 'settings.teams.cancel' | translate }}
      </app-button>
      <app-button variant="filled" color="primary" [disabled]="saving()" (click)="save()" data-testid="save-team-button">
        {{ 'settings.teams.save' | translate }}
      </app-button>
    </div>
  </app-modal-dialog>
}
